import React, { FC } from 'react';
import styled from '@emotion/styled';
import { LinearProgress, Typography } from '@mui/material';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { FocusTheme } from '@/components/Focus/configs/theme';

type RightsUtilizationProgressProps = { utilizationCount: number; utilizationMax: number };

const RightsUtilizationProgress: FC<RightsUtilizationProgressProps> = ({ utilizationCount, utilizationMax }) => {
  const getPercentage = () => {
    if (utilizationMax <= 0) return 0;
    return Math.round((utilizationCount / utilizationMax) * 100);
  };

  return (
    <StyledRoot>
      <StyledLeftLabel variant="body1">Rights Utilization:</StyledLeftLabel>
      <PolarisIcon height={20} icon="info" />
      <StyledBar aria-label="Rights utilization progress" variant="determinate" value={getPercentage()} />
      <StyledRightLabel variant="body2">{getPercentage()}%</StyledRightLabel>
    </StyledRoot>
  );
};

export default RightsUtilizationProgress;

const StyledRoot = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
`;

const StyledLeftLabel = styled(Typography)`
  white-space: nowrap;
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[10]};
  font-size: 16px; // need to redefine in theme
  font-weight: 700;
  letter-spacing: -0.16px;
`;

const StyledBar = styled(LinearProgress)`
  flex: 1;
  height: 8px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ theme }) => theme.palette.action.hover};

  .MuiLinearProgress-bar {
    border-radius: ${({ theme }) => theme.shape.borderRadius}px 0 0 ${({ theme }) => theme.shape.borderRadius}px;
    background: linear-gradient(90deg, #3887f4 0%, #38dddf 100%);
  }
`;

const StyledRightLabel = styled(Typography)`
  color: ${({ theme }) => (theme as FocusTheme).palette.neutral[10]};
  font-weight: 700;
  white-space: nowrap;
  text-align: right;
  font-size: 16px; // need to redefine in theme
`;
